module.exports = __webpack_public_path__ + "static/mujeres007-b65d2bd2bcc8ceb9a18e7811e54913e2.jpg";